import React, { createContext, useCallback, useContext, useLayoutEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'

import { RULES, validRule } from '../../../../../constants/Entitlements'
import { useSearchParams } from '../../../../../hooks'
import { createValidationSchema } from '../helpers/validationSchemas'

const CreateActionContext = createContext(null)

export const CreateActionProvider = ({ children }) => {
  const [isPreview, setIsPreview] = useState(false)
  const [isReadOnly, setIsReadOnly] = useState(false)
  const [validationSchema, setValidationSchema] = useState(createValidationSchema())
  const [isSubmitting, setIsSubmitting] = useState(false)

  /*
    [AD-14811] Lock de submit compartilhado entre o ActionHeader (que dispara) e o ActionForm (que salva).
    Precisa ser ref, e nao estado: estado e capturado pelo closure do render anterior, entao cliques
    concorrentes leem sempre `false`. `beginSubmit` e sincrono e roda no proprio clique, antes de qualquer
    await -- e o `isSubmitting` de estado existe apenas para desabilitar os botoes.
  */
  const isSubmittingRef = useRef(false)

  const beginSubmit = useCallback(function beginSubmit() {
    if (isSubmittingRef.current) return false

    isSubmittingRef.current = true
    setIsSubmitting(true)
    return true
  }, [])

  const endSubmit = useCallback(function endSubmit() {
    isSubmittingRef.current = false
    setIsSubmitting(false)
  }, [])

  const [searchParams] = useSearchParams()
  const currentUser = useSelector((state) => state.auth.auth)
  const params = useParams()
  const history = useHistory()

  const actionId = params.id
  const isNewAction = !actionId

  useLayoutEffect(function onMount() {
    const hasAccess = validRule(RULES.ACTION)
    if (!hasAccess) return history.push('/home')

    const readOnly = searchParams.get('readOnly')
    setIsReadOnly(readOnly === true || isPreview)
  }, [])

  return (
    <CreateActionContext.Provider
      value={{
        isNewAction,
        actionId,
        currentUser,
        isPreview,
        setIsPreview,
        isReadOnly,
        setIsReadOnly,
        validationSchema,
        setValidationSchema,
        isSubmitting,
        beginSubmit,
        endSubmit
      }}
    >
      {children}
    </CreateActionContext.Provider>
  )
}

export const useCreateActionContext = () => {
  const context = useContext(CreateActionContext)

  if (!context) {
    throw new Error('useCustomFields must be used with an CustomFieldsProvider')
  }

  return context
}
